import { getStripePublishableKey } from '../config';

let currentSetup = () => {
  console.log('stripe: no-op wrapper');
};

export function setSetupStripeFunction(setupStripe) {
  console.log('stripe: updating setup wrapper');
  currentSetup = setupStripe;
}

export function setupStripe(reason) {
  console.log('stripe: setup (calling setup wrapper)', reason);
  const publishableKey = getStripePublishableKey();
  currentSetup(publishableKey);
}
